import loadable from '@loadable/component';
import React from 'react';
import {
    IFrontendContext,
    MODAL_TYPES,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';

export const useModals = () => {
    const [modal, setModal] = React.useState<any>(null);
    const frontendContext: IFrontendContext = useFrontendContext();
    const userContext: IUserContext = useUserContext();

    React.useEffect(() => {
        if (
            frontendContext.state.showModal ===
            MODAL_TYPES.softAccountActivation
        ) {
            const SoftAccountSection = loadable(
                () => import('../softAccountSection'),
            );

            setModal(<SoftAccountSection />);
        } else if (
            frontendContext.state.showModal === MODAL_TYPES.forgotPassword
        ) {
            const ForgotPasswordSection = loadable(
                () => import('../forgotPasswordSection'),
            );

            setModal(
                <ForgotPasswordSection
                    previousFormEmail={userContext.state.lookup.lookedAccount}
                />,
            );
        } else if (
            frontendContext.state.showModal === MODAL_TYPES.passwordless
        ) {
            const PasswordlesSection = loadable(
                () => import('../passwordlessSection'),
            );

            setModal(
                <PasswordlesSection
                    // this may not work the same, the user may not have gone trough a lookup when pressing the  button
                    previousFormEmail={userContext.state.lookup.lookedAccount}
                />,
            );
        } else {
            setModal(null);
        }
    }, [
        frontendContext.state.showModal,
        userContext.state.lookup.lookedAccount,
    ]);

    return modal;
};
